module.exports = __webpack_public_path__ + "static/img/bgc4.27096946.jpg";